import { BULK_ACTIONS_RESOURCES, PAGE_NAMES } from 'constant';
import bulkRefund from 'assets/bulkActions/bulkRefund.png';
import bulkReply from 'assets/bulkActions/bulkReply.png';
import couponImg from 'assets/bulkActions/coupon.png';
import payInDetailsImg from 'assets/userProfile/deposits.png';

import BulkRefund from './bulkRefund';
import AllCoupons from './allCoupons';
import PayInDetails from './payInDetails';
import BulkReply from './bulkReply';

export const URL = {
	[BULK_ACTIONS_RESOURCES.bulkRefund]: `/${PAGE_NAMES.bulkActions}/${BULK_ACTIONS_RESOURCES.bulkRefund}`,
	[BULK_ACTIONS_RESOURCES.allCoupons]: `/${PAGE_NAMES.bulkActions}/${BULK_ACTIONS_RESOURCES.allCoupons}`,
	[BULK_ACTIONS_RESOURCES.payInDetails]: `/${PAGE_NAMES.bulkActions}/${BULK_ACTIONS_RESOURCES.payInDetails}`,
	[BULK_ACTIONS_RESOURCES.bulkReply]: `/${PAGE_NAMES.bulkActions}/${BULK_ACTIONS_RESOURCES.bulkReply}`
};

export const LABEL = {
	[BULK_ACTIONS_RESOURCES.bulkRefund]: 'Bulk Refund',
	[BULK_ACTIONS_RESOURCES.allCoupons]: 'All Coupons',
	[BULK_ACTIONS_RESOURCES.payInDetails]: 'PayIn Details',
	[BULK_ACTIONS_RESOURCES.bulkReply]: 'Bulk Reply'
};

export const COMPONENT = {
	[BULK_ACTIONS_RESOURCES.bulkRefund]: BulkRefund,
	[BULK_ACTIONS_RESOURCES.allCoupons]: AllCoupons,
	[BULK_ACTIONS_RESOURCES.payInDetails]: PayInDetails,
	[BULK_ACTIONS_RESOURCES.bulkReply]: BulkReply
};

export const IMAGE_SOURCE = {
	[BULK_ACTIONS_RESOURCES.bulkRefund]: bulkRefund,
	[BULK_ACTIONS_RESOURCES.allCoupons]: couponImg,
	[BULK_ACTIONS_RESOURCES.payInDetails]: payInDetailsImg,
	[BULK_ACTIONS_RESOURCES.bulkReply]: bulkReply
};
